import type Exportable from "./exportable";
import RefundApprovalResponse from "./refundApprovalResponse";
import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";

export default class Approvable implements Exportable {
  id: string;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals: RefundApprovalResponse[];

  isExported?: boolean;

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions?: RefundPermittedActionsResponse;
}
